/**
* @ngdoc directive
* @name Delete Item
*
* @description
  Trash icon which shows delete modal on click.
*
* @scope
* @param {String} childrenStyle - class added to children element
* @param {Function} deleteAction - callback on user confirms deletion
* @param {String} caption - optional caption of item to delete in confirmation modal
* @param {String} message - optional custom message to display in confirmation modal
*
* @example
  <delete-item
    children-style="'visible'"
    message="'This action cannot be undone. Are you sure you want to get it done?'"
    delete-action="alert">
  </delete-item>
*/

(function () {
  deleteItem.$inject = ["PATH"];
  app.directive('deleteItem', deleteItem);

  function deleteItem(PATH) {
    return {
      restrict: 'E',
      templateUrl: PATH.components + 'deleteItemDirective/deleteItemDirective.html',
      replace: true,
      scope: {
        childrenStyle: '=',
        deleteAction: '&',
        caption: '=?',
        message: '=?'
      },
      controller: 'DeleteItemController'
    };
  }
})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/deleteItemDirective/deleteItemDirective.js